import styled from '@emotion/styled';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem 8rem 2rem;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl || '2.4rem'};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi || '600'};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const ContentDescription = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	color: #212529;
	font-size: 1.6rem;
	line-height: 130%;
	letter-spacing: -0.6px;
	li {
		position: relative;
		padding-left: 1.5rem;
		&::after {
			content: '';
			position: absolute;
			top: calc(0.8em - 7px);
			left: 0;
			background-color: currentColor;
			width: 4px;
			height: 4px;
			border-radius: 50%;
		}
	}
`;
export const BasicInfoButtonBox = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.8rem;
	width: 100%;
	@media screen and (max-width: 600px) {
		flex-direction: column;
	}
`;
export const BlueButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 1.4rem 1.2rem;
	gap: 0.2rem;
	height: 100%;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	min-width: 18rem;
	cursor: pointer;
	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;
export const WhiteButton = styled(BlueButton)`
	background-color: #fff;
	color: ${(props) => props.theme.colors.primary400};
	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;
export const BasicInfo = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #212529;
	li {
		position: relative;
		padding-left: 1.5rem;
		&::after {
			content: '';
			position: absolute;
			top: calc(0.8em - 7px);
			left: 0;
			background-color: currentColor;
			width: 4px;
			height: 4px;
			border-radius: 50%;
		}
	}
`;
export const Table = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 2fr;
	grid-auto-rows: minmax(40px, auto);
	white-space: nowrap;
	overflow: auto;
	.item2 {
		grid-column-start: 1;
		grid-column-end: 3;
	}
	.item3 {
		grid-row-start: 2;
		grid-row-end: 4;
	}
`;
export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #00377b;
	color: white;
	padding: 10px 15px;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 150%;
	&.center {
		justify-content: center;
	}
`;
export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	&.point {
		color: #12539e;
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;
export const PositionCell = styled(TableCell)`
	color: #00377b;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;
export const PaymentBox = styled.div`
	display: grid;
	grid-template-columns: minmax(auto, 26.9rem) auto;
	grid-auto-rows: minmax(52px, auto);
`;
export const PaymentContentName = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary400};
	color: white;
	padding: 0.8rem 1.2rem;
	min-height: 5.2rem;
	border: 1px solid #fff;
	font-size: 1.6rem;
	font-weight: 500;
	line-height: 150%;
`;
export const PaymentContent = styled(PaymentContentName)`
	background-color: #f1f3f5;
	color: #212529;

	&.danger {
		color: ${(props) => props.theme.colors.red600};
	}
`;
